<div class="app">
    <ell-menu role="banner" />
    <main class="main-content mt-5 mb-5">
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    </main>
    <ell-footer role="contentinfo" />
</div>
